import axios from "axios";
import { del, get, patch, post, put } from "../util";
import { logCleApiError, toCleApiError } from "./errors";
import { getCleApiPrefix, isCleApiUrl } from "./endpoint";

export { getCleApiPrefix } from "./endpoint";

let interceptorRegistered = false;

const registerCleApiErrorInterceptor = (): void => {
  if (interceptorRegistered) return;
  interceptorRegistered = true;

  axios.interceptors.response.use(
    (response) => response,
    async (error) => {
      if (!axios.isAxiosError(error) || !isCleApiUrl(error.config?.url)) {
        return Promise.reject(error);
      }

      const cleError = await toCleApiError(error);
      if (import.meta.env.DEV) {
        logCleApiError(cleError);
      }
      return Promise.reject(cleError);
    },
  );
};

registerCleApiErrorInterceptor();

export const cleApi = {
  get: <T>(query: string): Promise<T> =>
    get<T>({ apiPrefix: getCleApiPrefix(), query }),
  post: <T>(query: string, body = {}): Promise<T> =>
    post<T>({ apiPrefix: getCleApiPrefix(), query, body }),
  put: <T>(query: string, body = {}): Promise<T> =>
    put<T>({ apiPrefix: getCleApiPrefix(), query, body }),
  patch: <T>(query: string, body = {}): Promise<T> =>
    patch<T>({ apiPrefix: getCleApiPrefix(), query, body }),
  del: <T>(query: string) => del<T>({ apiPrefix: getCleApiPrefix(), query }),
};
